import { render } from "./SignMandateContract.vue?vue&type=template&id=2372c0f2"
import script from "./SignMandateContract.vue?vue&type=script&lang=js"
export * from "./SignMandateContract.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__